import React, { useState } from 'react';
import LandingNav from './landing/LandingNav';
import Hero from './landing/Hero';
import StatsBand from './landing/StatsBand';
import RoleShowcase from './landing/RoleShowcase';
import FeatureSections from './landing/FeatureSections';
import IntegrationsBand from './landing/IntegrationsBand';
import MobileSection from './landing/MobileSection';
import Pricing from './landing/Pricing';
import FAQ from './landing/FAQ';
import ClosingCTA from './landing/ClosingCTA';
import LandingFooter from './landing/LandingFooter';
import DemoModal from './landing/DemoModal';

export default function LandingPage({ onLogin }) {
  const [demoOpen, setDemoOpen] = useState(false);
  const openDemo = () => setDemoOpen(true);

  return (
    <div className="min-h-screen bg-slate-950">
      <LandingNav onLogin={onLogin} onRequestDemo={openDemo} />

      <main>
        <Hero onLogin={onLogin} onRequestDemo={openDemo} />
        <StatsBand />
        <RoleShowcase />
        <FeatureSections />
        <IntegrationsBand />
        <MobileSection />
        <Pricing onRequestDemo={openDemo} />
        <FAQ />
        <ClosingCTA onLogin={onLogin} onRequestDemo={openDemo} />
      </main>

      <LandingFooter onLogin={onLogin} onRequestDemo={openDemo} />

      <DemoModal open={demoOpen} onClose={() => setDemoOpen(false)} />
    </div>
  );
}
